import React from "react";
import { useLocation } from "react-router-dom";
import { useMaintenance } from "@/contexts/MaintenanceContext";
import MaintenanceScreen from "@/components/MaintenanceScreen";

/**
 * Wraps the public Routes tree. When maintenance is on, renders the maintenance
 * screen for any non-admin route. Admin paths (/admin/*) always pass through so
 * the operator can still log in and disable maintenance.
 */
export default function PublicMaintenanceGate({ children }) {
  const { enabled, message, loaded } = useMaintenance();
  const location = useLocation();
  const path = location.pathname || "/";
  const isAdminPath = path === "/admin" || path.startsWith("/admin/");

  // Don't flash content before the first poll resolves (only ~5ms typically).
  if (!loaded) {
    return (
      <div
        className="min-h-screen bg-background"
        aria-hidden
        data-testid="maintenance-gate-loading"
      />
    );
  }

  if (enabled && !isAdminPath) {
    return <MaintenanceScreen message={message} />;
  }

  return children;
}
